export enum JobStatusPickerPopoverOptionEnum {
    CATEGORY_GROUP = 1,
    JOB_STATUS = 2
}



// WEBPACK FOOTER //
// ./src/app/atoms/job-status-picker-popover/job-status-picker-popover-option.enum.ts